<template>
  <span>
    {{ getTitle(cell) }}
  </span>
</template>

<script>
import { getTitle } from './wb-common';

export default {
  props: {
    cell: { type: Object, required: true },
    namespace: { type: String, required: true },
    mIndex: { type: String, default: '' },
  },
  data: () => ({ getTitle }),
};
</script>
